import React from "react";

import { Modal } from "antd";

/**
 * LDAS 공통 모달 — 헤더(타이틀) / 보더 바디(children) / 푸터(버튼 2개)
 *
 * Props
 *  - title       : 헤더 타이틀 (null 이면 헤더 숨김)
 *  - onCancel    : 취소 버튼 + X 버튼 핸들러
 *  - onOk        : 확인 버튼 핸들러
 *  - okText      : 확인 버튼 레이블 (기본 "저장")
 *  - cancelText  : 취소 버튼 레이블 (기본 "취소")
 */
const LdasModal = ({
  visible,
  onCancel,
  onOk,
  title,
  children,
  okText = "저장",
  cancelText = "취소",
  width = 520,
  destroyOnClose = true,
  maskClosable = true,
  closable = true,
  ...rest
}) => {
  const titleNode =
    title === null ? null : <div className="ldas-modal__title">{title}</div>;

  return (
    <Modal
      className="ldas-modal"
      wrapClassName="ldas-modal-wrap"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      title={titleNode}
      width={width}
      destroyOnClose={destroyOnClose}
      maskClosable={maskClosable}
      closable={closable}
      {...rest}
    >
      <div className="ldas-modal__card">
        <div className="ldas-modal__card-body">{children}</div>
        <div className="ldas-modal__footer">
          <button
            type="button"
            className="ldas-modal__btn ldas-modal__btn--secondary"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className="ldas-modal__btn ldas-modal__btn--primary"
            onClick={onOk}
          >
            {okText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LdasModal;
